import { useEffect, useState } from "react";
import PromptManagementStyles from "./PromptManagement.module.scss";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import { breadCrumbData } from "../../../../common/constants";
import { useBreadCrumbHook } from "../../../../hooks/common";
import Typography from "../../../../components/Typography/Typography";
import PromptInfoSvg from "../../../../assets/images/PromptLabelInfoSvg.svg";
import { adminManagementTabs } from "../constants";
import Tabs from "../../../../components/Tabs/Tabs";
import { Skeleton } from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import {
  addNewKeywordSectionForTTC,
  getPrompts,
  removeKeywordsWithNewKeywordType,
} from "../../store/admin.thunk";
import {
  defaultClauseStatus,
  PromptLabels,
  PromptsForFeature,
} from "../../constants";
import { isEmpty, times } from "underscore";
import NoData from "../../../../components/NoData/NoData";
import PromptManagementForContractReviewCard from "./PromptManagementForContractReviewCard";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { SimpleButton } from "../../../../components/Buttons/Buttons";
import PromptManagementForTTC from "./PromptManagementForTTC";
import arrowIcon from "../../../../assets/images/arrow_forward.svg";
import arrowBackIcon from "../../../../assets/images/arrow_backward.svg";

const PromptManagement = () => {
  const dispatch = useAppDispatch();
  const {
    [PromptsForFeature.CLAUSE_CHECK]: clauseCheckPrompts,
    [PromptsForFeature.CONTRACT_REVIEW]: contractReviewPrompts,
    [PromptsForFeature.TALK_TO_CONTRACT]: talkToContractPrompts,
  } = useAppSelector((state) => state.rootReducer.adminReducer);
  const [selectedAdminTab, setSelectedAdminTab] = useState(0);
  const [breadCrumb] = useBreadCrumbHook([
    breadCrumbData.dashboard,
    breadCrumbData.clauseManagement,
  ]);
  const data: any = talkToContractPrompts?.data;
  const isNewKeywordPresent =
    data &&
    data[0]?.rules?.some(
      (rule: any) => rule?.type === defaultClauseStatus.NEW_KEYWORD
    );

  const handleAddKeyword = () => {
    dispatch(addNewKeywordSectionForTTC());
  };

  useEffect(() => {
    if (isEmpty(contractReviewPrompts)) {
      dispatch(
        getPrompts({
          feature: PromptsForFeature.CONTRACT_REVIEW,
        })
      );
    }
    if (isEmpty(talkToContractPrompts)) {
      dispatch(
        getPrompts({
          feature: PromptsForFeature.TALK_TO_CONTRACT,
        })
      );
    }
  }, [
    clauseCheckPrompts,
    contractReviewPrompts,
    dispatch,
    talkToContractPrompts,
  ]);

  return (
    <div className={PromptManagementStyles.promptManagement}>
      {/* <Breadcrumb list={breadCrumb} styles={{ marginBottom: "0" }} /> */}
      <Typography
        fontSize={14}
        fontWeight={500}
        lineHeight="24.26px"
        color="#000000B2"
      >
        Clause Management
      </Typography>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Tabs
          tabs={adminManagementTabs}
          value={selectedAdminTab}
          handleTabClick={(_: any, tab: any) => {
            setSelectedAdminTab(tab);
          }}
          key="prompt_management_tab"
        />
        {/* {selectedAdminTab === 1 && (
          <SimpleButton
            variant="outlined"
            onClick={handleAddKeyword}
            disabled={isNewKeywordPresent}
          >
            <Typography fontSize={14} fontWeight={500}>
              Add Keyword
            </Typography>
          </SimpleButton>
        )} */}
      </div>
      <div className={PromptManagementStyles.contentWrapper} style={{background: "#fff"}}>
        {PromptLabels.at(selectedAdminTab) && (
          <div className={PromptManagementStyles.label}>
            <img src={PromptInfoSvg} alt="" style={{width: "12px", height: "12px"}}/>
            <span style={{fontSize: "12px", fontWeight: "400"}}>{PromptLabels[selectedAdminTab]?.value}</span>
          </div>
        )}
        {selectedAdminTab === 0 && (
          <PromptManagementForContractReviewContainer
            contractReviewPrompts={contractReviewPrompts}
          />
        )}
        {selectedAdminTab === 1 && (
          <div className={PromptManagementStyles.ttcWrapper}>
            <div className={PromptManagementStyles.existKeyword}>
              <span style={{fontSize: "14px", fontWeight: "500"}}>Existing Keywords</span>
              <SimpleButton
                variant="outlined"
                onClick={handleAddKeyword}
                disabled={isNewKeywordPresent}
                style={{borderRadius: "24px"}}
              >
                <Typography fontSize={12} fontWeight={500}>
                  Add New Keyword
                </Typography>
              </SimpleButton>
            </div>
            <PromptManagementForTalkToContractContainer
              prompts={talkToContractPrompts}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const PromptManagementForContractReviewContainer = ({
  contractReviewPrompts,
}: any) => {
  const [selectedSubclause, setIsSelectedSubclause] = useState({
    displayName: "",
  });

  useEffect(() => {
    if (
      isEmpty(selectedSubclause?.displayName) &&
      contractReviewPrompts?.data?.length > 0
    ) {
      setIsSelectedSubclause(contractReviewPrompts?.data?.[0]);
    }
  }, [contractReviewPrompts, selectedSubclause]);

  const loading = contractReviewPrompts?.loading;

  const handleSubClauseClick = (promptText: { displayName: string }) => {
    setIsSelectedSubclause(promptText);
  };

  return (
    <div
      className={
        PromptManagementStyles.promptManagementContainerForContractReview
      }
    >
      <div className={PromptManagementStyles.subclauseContainer}>
        {contractReviewPrompts?.data?.map((prompt: any) => {
          const selected =
            prompt?.displayName === selectedSubclause?.displayName;

          if (loading) {
            const skeleton = times(1, () => (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                style={{ borderRadius: "10px" }}
              />
            ));
            return skeleton;
          }
          return (
            <Tooltip
              title={<Typography>{prompt?.displayName}</Typography>}
              overlayInnerStyle={{ display: "flex", alignItems: "center" }}
            >
              <div
                className={PromptManagementStyles.subclauseText}
                style={{
                  background: selected
                    ? "var(--offBlueColor-5Percent)"
                    : "var(--primaryWhiteColor)",
                }}
                onClick={() => handleSubClauseClick(prompt)}
              >
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  lineHeight="26px"
                  color={
                    selected
                      ? "var(--text-selected-grey-color)"
                      : "var(--text-unselected-grey-color)"
                  }
                  style={{
                    whiteSpace: "nowrap",
                    width: "100%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {prompt?.displayName}
                </Typography>
                {selected ? <img src={arrowBackIcon} alt="" /> : <img src={arrowIcon} alt="" />}
              </div>
            </Tooltip>
          );
        })}
      </div>
      <div className={PromptManagementStyles.subclauseEditorContainer}>
        {RenderPrompts({
          promptData: selectedSubclause,
          Comp: PromptManagementForContractReviewCard,
          dontMap: true,
          noDataText:
            "Select a standard clause to view or edit threshold values",
          props: {
            setIsSelectedSubclause: setIsSelectedSubclause,
          },
        })}
      </div>
    </div>
  );
};

const PromptManagementForTalkToContractContainer = ({ prompts }: any) => {
  const data = prompts?.data ? prompts?.data[0] : [];
  const rules = data?.rules || [];
  const allWords = rules?.map((data: any) => data?.Word);
  const isNewKeyword =
    rules?.filter((rule: any) => rule?.type === defaultClauseStatus.NEW_KEYWORD)
      ?.length > 0;
  const [selectedSubclause, setIsSelectedSubclause] = useState({
    rule: {
      Synonyms: [""],
      Word: "",
      type: "",
    },
    id: 0,
  } as any);
  const [newKeywordShown, setIsNewKeywordShown] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isNewKeyword && !newKeywordShown) {
      setIsSelectedSubclause({ ...selectedSubclause, rule: rules[0] });
      setIsNewKeywordShown(true);
    }
    if (isEmpty(selectedSubclause?.rule?.Word) && rules?.length > 0) {
      setIsSelectedSubclause({ ...selectedSubclause, rule: rules[0] });
    }
    return () => {
      setIsNewKeywordShown(false);
    };
  }, [isNewKeyword]);

  useEffect(() => {
    return () => {
      dispatch(removeKeywordsWithNewKeywordType());
    };
  }, [dispatch]);

  const loading = prompts?.loading;

  const handleSubClauseClick = (selectedRule: {
    rule: {
      Synonyms: string[];
      Word: string;
      type: string;
    };
    id: number;
  }) => {
    setIsSelectedSubclause({
      rule: selectedRule?.rule,
      id: selectedRule?.id,
    });
  };

  return (
    <div
      className={
        PromptManagementStyles.promptManagementContainerForContractReview
      }
    >
      <div className={PromptManagementStyles.subclauseContainer}>
        {rules?.map((rule: any, idx: number) => {
          const selected = rule?.Word === selectedSubclause?.rule?.Word;

          if (loading) {
            const skeleton = times(1, () => (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                style={{ borderRadius: "10px" }}
              />
            ));
            return skeleton;
          }
          return (
            <Tooltip
              title={<Typography>{rule?.Word || "Add Keyword"}</Typography>}
              overlayInnerStyle={{ display: "flex", alignItems: "center" }}
            >
              <div
                className={PromptManagementStyles.subclauseText}
                style={{
                  background: selected
                    ? "var(--offBlueColor-5Percent)"
                    : "var(--primaryWhiteColor)",
                }}
                onClick={() =>
                  handleSubClauseClick({
                    rule: rule,
                    id: idx,
                  })
                }
              >
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  lineHeight="26px"
                  color={
                    selected
                      ? "var(--text-selected-grey-color)"
                      : "var(--text-unselected-grey-color)"
                  }
                  style={{
                    whiteSpace: "nowrap",
                    width: "100%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {rule?.Word || "Add Keyword"}
                </Typography>
                {selected ? <img src={arrowBackIcon} alt="" /> : <img src={arrowIcon} alt="" />}
              </div>
            </Tooltip>
          );
        })}
      </div>
      <div className={PromptManagementStyles.subclauseEditorContainer}>
        {RenderPrompts({
          promptData: selectedSubclause.rule,
          Comp: PromptManagementForTTC,
          dontMap: true,
          noDataText: "Select a keyword to view or edit synonyms",
          props: {
            rule: selectedSubclause.rule,
            idx: selectedSubclause?.id,
            allWords: allWords,
            setIsSelectedSubclause: setIsSelectedSubclause,

            onKeywordDelete: () => {
              setIsSelectedSubclause({});
            },
          },
        })}
      </div>
    </div>
  );
};

const RenderPrompts = ({
  promptData,
  Comp,
  dontMap,
  props,
  noDataText,
}: {
  promptData: any;
  Comp: any;
  dontMap?: boolean;
  props?: any;
  noDataText?: string;
}) => {
  if (promptData?.loading) {
    const skeleton = times(1, () => (
      <div style={{ padding: "20px" }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={180}
          style={{ borderRadius: "10px" }}
        />
      </div>
    ));
    return skeleton;
  }
  if (isEmpty(promptData) || promptData?.data?.length === 0) {
    return <NoData text={noDataText} />;
  }
  return dontMap ? (
    <Comp
      key={promptData?.id || promptData?.Word}
      prompt={promptData}
      {...props}
    />
  ) : (
    promptData?.data?.map((prompt: any) => (
      <Comp key={prompt?.id || prompt?.Word} prompt={prompt} {...props} />
    ))
  );
};

export default PromptManagement;
